document.addEventListener('show.te.offcanvas', () => {
  document.documentElement.classList.add('overflow-hidden');
});

document.addEventListener('hide.te.offcanvas', () => {
  document.documentElement.classList.remove('overflow-hidden');
});
